
























































































































































































































import { Vue, Component, PropSync, Watch, Prop, Ref } from 'vue-property-decorator';
import { NCPResponse, YorN } from 'ncp-api-supporter';
import { GetDeliveryTemplate } from 'ncp-api-supporter/dist/types/modules/delivery/deliveryTemplate';
import { TranslateResult } from 'vue-i18n';
import SelectBox from '@/pro/components/common/SelectBox.vue';
import ToolTip from '@/pro/components/common/tooltip/ToolTip.vue';
import RadioGroup from '@/pro/components/common/RadioGroup.vue';
import TextInput from '@/pro/components/common/input/TextInput.vue';
import {DeliveryInfoFocusType, DeliveryInformation, DeliveryInformationModel, EditFlag, InputNumber} from '@/pro/types';
import {DELETE_ERROR, IMMUTABLE_FIELD, PRODUCT_FORM_ERROR_TYPE} from '@/pro/const/contents/product';
import {OptionData} from '@/pro/helpers/type';
import {
  defaultDeliveryTemplate,
  DefaultDeliveryTemplate,
  selectOption,
} from '@/pro/views/contents/product/basic/ProductAdd/deliveryInfo/DeliveryInfo';
import {i18nForProduct} from '@/pro/views/contents/product/basic/ProductAdd/ProductAdd';
import {formatCurrency} from '@/pro/utils/numberFormat';
import {PopupClose, throwPopup} from '@/pro/helpers/popup';
import {MODE} from '@/pro/const/common';
import {Admin} from '@/types';
import {namespace} from 'vuex-class';
import {DeliveryCompany} from 'supporter';

enum WareHouse {
  releaseWarehouse = 'releaseWarehouse',
  returnWarehouse = 'returnWarehouse',
}

const adminModule = namespace('admin');
const deliveryModule = namespace('delivery');

@Component({
  components: { SelectBox, ToolTip, RadioGroup, TextInput },
})
export default class DeliveryInfo extends Vue {
  @deliveryModule.Getter('deliveryCompanies') deliveryCompanyTypes!: DeliveryCompany[];

  @PropSync('deliveryInfo')
  private deliveryInfoSync!: DeliveryInformation;

  @Prop({ required: true })
  private readonly deliveryInfoModel: DeliveryInformationModel;

  @Prop()
  private readonly mallNo: InputNumber;

  @Prop()
  private readonly isSelectedMall: boolean;

  @Prop({ required: true })
  private readonly disabled;

  @Prop({ required: true })
  private readonly editFlag: EditFlag;

  @Prop({ required: true })
  private readonly immutableFields;

  @Prop({ required: true })
  private readonly isCopyWithStockMode: boolean;

  private readonly IMMUTABLE_FIELD = IMMUTABLE_FIELD;

  @Ref()
  private readonly deliveryTemplateRef!: SelectBox;

  @Ref()
  private readonly deliveryInfoRef!: RadioGroup;

  @adminModule.Getter('admin')
  private stateAdmin!: Admin;

  private selectOption: OptionData<YorN>[] = selectOption;

  public alertDeliveryTemplate(): void {
    alert(i18nForProduct('PLZ_SELECT_TEMPLATE'));
    this.onFocus('deliveryInfo');
  }

  public onFocus(focusTarget: DeliveryInfoFocusType): void {
    this[`${focusTarget}Ref`].focus();
  }

  private get useDelivery(): boolean {
    return this.deliveryInfoSync.deliveryYn === 'Y';
  }

  private get vacantTemplates(): boolean {
    return !this.deliveryTemplates.length;
  }

  private deliveryTemplateNo: InputNumber = '';
  private changedDeliveryTemplates(templateNo: number): void {
    this.deliveryInfoSync.deliveryTemplateNo = templateNo;
		this.setSelectedDeliveryTemplate();
  }

  private get needAllForTemplates(): boolean {
    return !this.isSelectedMall || this.vacantTemplates;
  }

  private get needAllTextForTemplates(): TranslateResult {
    if (!this.isSelectedMall) {
      return this.$t('PRO_PRODUCT_ADD_PLZ_SELECT_SHOPPING_MALL');
    }
    if (this.vacantTemplates) {
      return this.$t('PRO_PRODUCT_ADD_PLZ_ADD_TEMPLATE');
    }
    return '';
  }

  private currentDeliveryCompany(name: string): string {
    const result = this.deliveryCompanyTypes.find(company => company.deliveryCompanyType === name);
    return result ? result.label : '';
  }

  private checkSelectedMall(): void {
    this.$emit(this.deleteError, ['INVALID_DELIVERY_TEMPLATE_NO', 'NON_EDITABLE_DELIVERY_TEMPLATE_NO']);
    !this.isSelectedMall && this.$emit('alertMallSelect');
  }

  private changedDeliveryYn(curr: YorN): void {
    if (!this.editFlag.isMapping || curr === 'Y') return;
    this.undoChanges();
  }

  private undoChanges(): void {
    alert(i18nForProduct('NOTICE_DELIVERY_TEMPLATE'));
    this.$nextTick(() => {
      this.deliveryInfoSync.deliveryYn = 'Y';
    });
  }

  private deliveryTemplates: GetDeliveryTemplate[] = [];
  @Watch('mallNo')
  private async resetDeliveryTemplate() {
    await this.fetchDeliveryTemplates();
    this.setDefaultDeliveryTemplate();
		this.setSelectedDeliveryTemplate();
  }

  private async fetchDeliveryTemplates(): Promise<void> {
    this.deliveryTemplates = await this.getDeliveryTemplates();
  }

  private async getDeliveryTemplates(): Promise<GetDeliveryTemplate[]> {
    this.deliveryInfoSync.shippingAreaPartnerNo = this.stateAdmin.partnerNo;
    const { data }: NCPResponse<GetDeliveryTemplate[]> = await this.$api.getDeliveryTemplates({
      params: { partnerNo: this.deliveryInfoSync.shippingAreaPartnerNo },
    });
    return data;
  }

  private setDefaultDeliveryTemplate(): void {
    if (this.preventDefaultTemplateNo) {
      this.preventDefaultTemplateNo = false;
      return;
    }
    const defaultTemplate = this.deliveryTemplates.find(template => template.default);
    this.deliveryInfoSync.deliveryTemplateNo = this.getDefaultTemplateNo(defaultTemplate);
    this.deliveryTemplateNo = this.deliveryInfoSync.deliveryTemplateNo;
  }

  private getDefaultTemplateNo(defaultTemplate: DefaultDeliveryTemplate): number {
    return defaultTemplate ? defaultTemplate.templateNo : this.deliveryTemplates[0].templateNo;
  }
	
	private selectedDeliveryTemplate: DefaultDeliveryTemplate = { ...defaultDeliveryTemplate };

  private setSelectedDeliveryTemplate() {
    // TODO deliveryTypeLabel -> undefined error 때문에 임시처리함. 정리예정
    this.selectedDeliveryTemplate = this.deliveryInfoSync.deliveryTemplateNo
      ? { ...defaultDeliveryTemplate, ...this.getSelectedDefaultDeliveryTemplate() }
      : { ...defaultDeliveryTemplate };
  }

  private getSelectedDefaultDeliveryTemplate(): GetDeliveryTemplate {
    const current = this.deliveryTemplates.find(
      template => template.templateNo === this.deliveryInfoSync.deliveryTemplateNo,
    );
    if (current) return current;

    const defaultTemplate = this.deliveryTemplates.find(template => template.default);
    if (defaultTemplate) return defaultTemplate;
  }

  private get releaseWarehouseAddress(): string {
		const releaseWarehouse = this.selectedDeliveryTemplate[WareHouse.releaseWarehouse];
	  return releaseWarehouse.address
		  ? releaseWarehouse.address.addressStr
		  : releaseWarehouse.substitutionText;
  }

  private get returnWarehouseAddress(): string {
		const returnWarehouse = this.selectedDeliveryTemplate[WareHouse.returnWarehouse]
	  return returnWarehouse.address
		  ? returnWarehouse.address.addressStr
		  : returnWarehouse.substitutionText;
  }

  private get returnDeliveryAmt(): string {
    const amt = this.selectedDeliveryTemplate.deliveryFee.returnDeliveryAmt;
    return !amt ? '0' : formatCurrency(amt);
  }

  private setAddedTemplate(templateNo: number) {
    this.deliveryInfoSync.deliveryTemplateNo = templateNo;
    this.deliveryTemplateNo = templateNo;
    this.fetchDeliveryTemplates();
  }
  private openPopup(type: string): void {
    if (!this.isSelectedMall) {
      this.checkSelectedMall();
      return;
    }

    switch (type) {
      case 'addDeliveryTemplate':
        throwPopup({
          name: 'DeliveryTemplateForm',
          data: { mode: MODE.REGISTER, template: null },
        }).then(res => {
          if (res && res.state === PopupClose.CONFIRM) {
            this.setAddedTemplate(res.data);
          }
        });
        break;
    }
  }

  private preventDefaultTemplateNo = false;
  @Watch('deliveryInfoModel.deliveryTemplateNo')
  private setInit() {
    if (!this.deliveryInfoModel.deliveryTemplateNo) return;
    this.deliveryTemplateNo = this.deliveryInfoModel.deliveryTemplateNo;
    this.preventDefaultTemplateNo = true;
  }
  // error
  @Prop({ required: true })
  private readonly formError: { [errorKey: string]: string };
  @Prop({ required: true })
  private readonly formErrorType: typeof PRODUCT_FORM_ERROR_TYPE;
  @Prop({ required: true })
  private readonly deleteError: typeof DELETE_ERROR;
}
